import React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const ClockWatch = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
    >
      <circle
        cx={12}
        cy={12}
        r={9.004}
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.455 13.152 12 12.001V5.998"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { ClockWatch };
